import classNames from "classnames";
import React from "react";

import { CheckSvg } from "../svg/CheckSvg";

type Props = {
  value: boolean;
  onChange: (value: boolean) => void;
};

export const SettingsCheckbox: React.FC<Props> = ({ value, onChange }) => {
  return (
    <div
      onClick={() => onChange(!value)}
      className={classNames(
        "transitions-all flex h-4 w-4 items-center justify-center rounded-sm border p-1 text-white duration-300",
        value ? "border-[#6938EF] bg-[#6938EF]" : "border-[#A1AFC0]",
      )}>
      <CheckSvg sizeCx={"w-4 h-4"} />
    </div>
  );
};
